import Page404 from 'pages/page404/page404'
import PrivacyPage from 'pages/privacy'
import SearchPage from 'pages/search/search'
import TermPage from 'pages/term'
import { lazy } from 'react'
import { BOOKMARK, HELP, HISTORY, HOME, LOGIN, PDF_VIEW, PRIVACY, SEARCH, TERM, MAINTENANCE } from './configs/path'
import { routerType } from './models/common'

const HomePage = lazy(() => import('./pages/home'))
const LoginPage = lazy(() => import('./pages/login/Login'))
const HistoryPage = lazy(() => import('./pages/history'))
const BookmarkPage = lazy(() => import('./web/Bookmark/Bookmark'))
const PDFPage = lazy(() => import('./pages/PDFPage/PDFPage'))
const HelpPage = lazy(() => import('./pages/help/HelpPage'))
const MaintenancePage = lazy(() => import('./pages/maintenance/Maintenance'))

export const unAuth: routerType[] = [
  {
    path: LOGIN,
    element: <LoginPage />
  },
  {
    path: '*',
    element: <Page404 />
  }
]

export const privateRouter: routerType[] = [
  {
    path: HOME,
    element: <HomePage />
  },
  {
    path: SEARCH,
    element: <SearchPage />
  },
  {
    path: HISTORY,
    element: <HistoryPage />
  },
  {
    path: BOOKMARK,
    element: <BookmarkPage />
  },
  {
    path: HELP,
    element: <HelpPage />
  },
  {
    path: '*',
    element: <Page404 />
  }

]

export const defaultRouter: routerType[] = [
  {
    path: MAINTENANCE,
    element: <MaintenancePage />
  }
]

export const publicRouter: routerType[] = [
  {
    path: TERM,
    element: <TermPage />
  },
  {
    path: PRIVACY,
    element: <PrivacyPage />
  },
  {
    path: PDF_VIEW,
    element: <PDFPage />
  },
  {
    path: '*',
    element: <Page404 />
  }
]
